import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

export const Heading = ({ style, ...props }: BoxProps) => {
  const isDesktopWeb = useIsDesktopWebBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.heading, isDesktopWeb && styles.headingDesktop, style],
  });
};

export const CartErrorHeading = withTypography({
  variant: 'hero',
  lineHeight: 'xs',
  textAlign: 'center',
  style: {
    margin: 0,
    marginTop: spacing.$20,
  },
});

const styles = StyleSheet.create({
  heading: {
    alignItems: 'center',
  },
  headingDesktop: {
    paddingTop: spacing.$5,
  },
});
